import useIntercomCustomAttributes from '@hooks/lib/useIntercomCustomAttributes';
import { boot, Intercom } from '@intercom/messenger-js-sdk';
import { useAuth } from '@lusha/auth-client-sdk';
import { useEffect } from 'react';
function LushaIntercomProvider(props) {
    const { children, isExtensionMode = false } = props;
    const customAttributes = useIntercomCustomAttributes();
    const { user } = useAuth();
    const { email } = user || {};
    useEffect(() => {
        if (!isExtensionMode && email) {
            Intercom(Object.assign({ region: 'eu' }, customAttributes));
            boot(customAttributes);
        }
    }, [email, isExtensionMode]);
    return children;
}
export default LushaIntercomProvider;
